export const MESSAGE_TYPES = {
  USER: "user",
  LIS: "lis",
  TEXT: "text",
  AUDIO: "audio",
} as const;

export const MAX_AUDIO_RESPONSE_LENGTH = 300;
